import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../../../button/button.module';
import { LoadingIndicatorModule } from '../../../loading-indicator/loading-indicator.module';
import { SelectBoxModule } from '../../../select-box/select-box.module';
import { AddressSearchBarComponent } from './address-search-bar.component';

@NgModule({
  imports: [
    CommonModule,
    SelectBoxModule,
    ButtonModule,
    LoadingIndicatorModule,
  ],
  declarations: [AddressSearchBarComponent],
  exports: [AddressSearchBarComponent],
})
export class AddressSearchBarModule {}
